module.exports = __webpack_public_path__ + "media/images/but-create-app-b56d86ae.png";